import React from 'react';
import "./index.scss"

export default function TextContent ({component}) {
    const {content} = component;

    return (
        <article className="text__article" dangerouslySetInnerHTML={{__html: content}}/>
    )
}